<template lang="html">
  <div v-if="greetings" class="greeting-list-container">
    <div class="search media">
      <div class="media-body row">
        <div class="col">
          <search-input
            :placeholder="$t('label.search')"
            @search="searchGreetingWithName"
          >
          </search-input>
        </div>
        <div class="col">
          <search-input
            :placeholder="$t('label.search_home_project')"
            @search="searchGreetingWithHome"
          >
          </search-input>
        </div>
      </div>
    </div>
    <div class="col p-0 greeting-list">
      <greeting-navigation :greetings="membersFilter" />
    </div>
    <greeting-summary v-if="keyword === ''" :total="membersFilter.length" />
  </div>
</template>
<script>
import SearchInput from "@/components/helper/SearchInput"
import GreetingNavigation from "./GreetingNavigation"
import GreetingSummary from "./GreetingSummary"

export default {
  components: {
    SearchInput,
    GreetingSummary,
    GreetingNavigation,
  },
  props: {
    greetings: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      keyword: "",
      searchName: "",
      searchHome: "",
    }
  },
  computed: {
    membersFilter() {
      return this.greetings || []
    },
  },
  methods: {
    searchGreetingWithName(searchName) {
      const { searchHome } = this
      this.searchName = searchName
      this.$emit("search", { searchName, searchHome })
    },
    searchGreetingWithHome(searchHome) {
      const { searchName } = this
      this.searchHome = searchHome
      this.$emit("search", { searchName, searchHome })
    },
  },
}
</script>
<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 10;
}
.greeting-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.greeting-list {
  overflow: auto;
}
</style>
